import { useTheme } from '@mui/material';
import { Avatar } from '@portals/core/src/components/Avatar/Avatar';
import type { Theme } from '@portals/core/src/themes/themes';
import React, { MouseEventHandler } from 'react';

import { loadCategory } from '../../utils/loadCategory';
import { getStyles } from './CategoryIcon.styles';

interface Props {
  category: string;
  onClick?: MouseEventHandler<HTMLElement>;
}

export const CategoryIcon: React.FunctionComponent<Props> = ({ category, ...props }: Props) => {
  const { Icon, color } = loadCategory(category);
  const theme = useTheme<Theme>();
  const styles = getStyles(theme, color);

  return (
    <Avatar sx={styles.avatarStyles} {...props}>
      <Icon fontSize="inherit" sx={styles.icon} />
    </Avatar>
  );
};
